import "./NotPayable.css";

import Modal from "react-modal";
import { setNotPayableVisible } from "../../../store/modals/modalActions";
import { useAppDispatch } from "../../../hooks/reduxHooks";

const NotPayable = () => {
  const dispatch = useAppDispatch();
  const modalStyle = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      overflow: "hidden",
      border: 0,
      boxShadow: "1px 0px 19px -4px rgba(0, 0, 0, 0.3)",
      height: 300,
      width: window.innerWidth > 480 ? "50%" : "75vw",
    },
  };
  const onBackToSearchClicked = () => {
    dispatch(setNotPayableVisible(false));
  };
  return (
    <Modal isOpen={true} style={modalStyle}>
      <div className="not-payable-container">
        <p className="not-payable-heading">Fine not payable</p>
        <p className="not-payable-subheading">
          Unfortunately this fine cannot be paid at this time.
        </p>
        <div
          className="back-to-search-modal"
          onClick={() => onBackToSearchClicked()}
        >
          <p>Back to Search</p>
        </div>
      </div>
    </Modal>
  );
};

export default NotPayable;
